export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: 'fill'
    },
    lazy: {
      type: Boolean,
      default: false
    },
    /** 是否开启预览 */
    preview: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    errorImg: function errorImg() {
      var _this$$store$state$sy;
      return (_this$$store$state$sy = this.$store.state.sysConfig) === null || _this$$store$state$sy === void 0 ? void 0 : _this$$store$state$sy.errorImg;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};